import { BusinessHours } from '@/components/business-hours/business-hours';
import { InitialMessage } from '@/components/initial-message/initial-message';
import { RedirectionTargets } from '@/components/redirection-targets/redirection-targets';
import { Tab } from '@/components/tab/tab';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';

export function Company() {
  const { t } = useTranslation('settings');
  const tabItems = [
    {
      key: 'initial-mess',
      label: t('tabs.initialMessage'),
      children: <InitialMessage />,
    },
    {
      key: 'business-hours',
      label: t('tabs.businessHours'),
      children: <BusinessHours />,
    },
    {
      key: 'redirection-targets',
      label: t('tabs.redirectionTargets'),
      children: <RedirectionTargets />,
    },
  ];

  return (
    <Flex vertical>
      <Tab items={tabItems} />
    </Flex>
  );
}
